module.exports = __webpack_public_path__ + "krecove-zily_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/krecove-zily_3_after_tn.jpg
// module id = 1497
// module chunks = 0